/* component-open-description.js */
(() => {
  "use strict";

  function isProductPage() {
    return location.pathname.includes('/products/') ||
           document.body.classList.contains('template-product') ||
           (document.documentElement.getAttribute('data-template') || '').includes('product');
  }

  function findDescriptionDetails(root = document) {
    // 1) Tarkka ID (joissain teemoissa)
    let el = root.querySelector('details#Description-the-description');
    if (el) return el;

    // 2) Tyypillisiä tuoteblokkeja
    el = root.querySelector('.product-block.product-block__description details');
    if (el) return el;

    // 3) Dawn- ja muut teemat: etsi <details> jossa otsikko "Kuvaus"
    const candidates = root.querySelectorAll('details');
    for (const d of candidates) {
      const label = d.querySelector('summary span, summary');
      const txt = (label?.textContent || "").trim().toLowerCase();
      if (txt === "kuvaus" || txt === "tuotekuvaus") return d;
    }
    return null;
  }

  function openDetailsIfNeeded(d) {
    if (!d || d.open) return;
    d.open = true; // natiivi
    d.dispatchEvent(new Event("toggle", { bubbles: true })); // yhteensopivuus
    const summary = d.querySelector("summary");
    if (summary) summary.setAttribute("aria-expanded", "true");
  }

  function tryOpenNow() {
    const d = findDescriptionDetails();
    if (d) openDetailsIfNeeded(d);
  }

  function initOnce() {
    if (!isProductPage()) return;
    if (document.documentElement.dataset.flOpenDescriptionInit === "1") return;
    document.documentElement.dataset.flOpenDescriptionInit = "1";

    // Havainnoi DOM
    const mo = new MutationObserver(() => tryOpenNow());
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Shopify-section -tapahtumat + selaimen navigaatio
    document.addEventListener("shopify:section:load", () => tryOpenNow(), { passive: true });
    window.addEventListener("popstate", () => queueMicrotask(tryOpenNow), { passive: true });

    tryOpenNow();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOnce, { once: true });
  } else {
    initOnce();
  }
})();
